import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is a B2B portal and why does my business need one?",
    answer: `<p>A B2B portal is a secure online platform that automates business interactions between companies. It streamlines operations, enhances collaboration, and improves efficiency by integrating partners, suppliers, and clients into a single digital ecosystem.</p>`,
  },
  {
    question: "How long does it take to develop a custom B2B portal?",
    answer: `<p>Development timelines vary based on complexity but typically range from 3 to 6 months. This includes design, development, testing, and deployment phases.</p>`,
  },
  {
    question: "Can the B2B portal integrate with our existing systems?",
    answer: ` <p>Yes, we build portals with full integration capabilities, including ERP, CRM, and third-party tools, ensuring seamless data flow and process continuity.</p>`,
  },
  {
    question: "How secure are your B2B portals?",
    answer: `<p>Our portals are built with enterprise-grade security, including multi-factor authentication, data encryption, and secure API integrations, ensuring complete protection against cyber threats.</p>`,
  },
  {
    question: "Is the portal scalable as our business grows?",
    answer: `<p>Absolutely. Our B2B portals are designed with scalable architecture, allowing easy upgrades and expansions as your business and user base grow.</p>`,
  },
  {
    question: "What ongoing support do you provide after the portal is live?",
    answer: ` <p>We offer full post-launch support, including maintenance, updates, security patches, and performance optimization to ensure the portal remains efficient and secure.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                <span>B2B Portal</span> Development FAQs
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
